import QRCode from 'react-qr-code';

import promoPhone from '@/assets/images/auth-promo/promo-phone.webp';
import LogoMain from '@/assets/svg/logos/logo-main.svg';
import { PagePaths } from '@/routes/page-paths';
import { StoreBadge } from '@/shared/components/store-badge';
import { Typography } from '@/shared/design-system';

import {
  PromoCopy,
  PromoFooter,
  PromoImage,
  PromoLight,
  PromoLogo,
  PromoPanel as PromoPanelRoot,
  PromoTitle,
  QrBlock,
  QrTile,
  StoreBadges,
} from './styled';

export const PromoPanel = () => {
  const getAppUrl = `${window.location.origin}${PagePaths.getApp}`;

  return (
    <PromoPanelRoot aria-labelledby="auth-promo-title">
      <PromoImage src={promoPhone} alt="" />
      <PromoLight aria-hidden="true" focusable="false">
        <defs>
          <linearGradient id="auth-promo-glow-fade" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="white" stopOpacity="0" />
            <stop offset="0.45" stopColor="white" stopOpacity="0.15" />
            <stop offset="0.75" stopColor="white" stopOpacity="0.3" />
            <stop offset="0.9" stopColor="white" stopOpacity="0.8" />
            <stop offset="0.98" stopColor="white" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="auth-promo-line-fade" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0.9" stopColor="white" stopOpacity="0" />
            <stop offset="0.97" stopColor="white" />
          </linearGradient>
          <mask id="auth-promo-glow-mask">
            <rect width="100%" height="100%" fill="url(#auth-promo-glow-fade)" />
          </mask>
          <mask id="auth-promo-line-mask">
            <rect width="100%" height="100%" fill="url(#auth-promo-line-fade)" />
          </mask>
          <filter id="auth-promo-glow-blur">
            <feGaussianBlur stdDeviation="2" />
          </filter>
        </defs>
        {/* No viewBox: the 24 px corner radius and stroke keep their size at any panel size. */}
        <rect
          width="100%"
          height="100%"
          rx="24"
          fill="none"
          stroke="currentColor"
          strokeWidth="8"
          mask="url(#auth-promo-glow-mask)"
          filter="url(#auth-promo-glow-blur)"
        />
        <rect
          width="100%"
          height="100%"
          rx="24"
          fill="none"
          stroke="currentColor"
          strokeWidth="4"
          mask="url(#auth-promo-line-mask)"
        />
      </PromoLight>
      <PromoLogo to={PagePaths.root} aria-label="Return to sign in">
        <LogoMain role="img" aria-label="Gamma Prime" focusable="false" />
      </PromoLogo>
      <PromoFooter>
        <PromoCopy>
          <PromoTitle id="auth-promo-title" as="h2" variant="h2">
            Get the <span>Gamma Prime app</span>
          </PromoTitle>
          <StoreBadges>
            <StoreBadge store="app-store" />
            <StoreBadge store="google-play" />
          </StoreBadges>
        </PromoCopy>
        <QrBlock>
          <Typography variant="body2" fontWeight={500} color="inherit">
            Scan the QR code to download the app
          </Typography>
          <QrTile role="img" aria-label="QR code to download the app" data-value={getAppUrl}>
            <QRCode
              value={getAppUrl}
              bgColor="transparent"
              fgColor="currentColor"
              aria-hidden="true"
            />
          </QrTile>
        </QrBlock>
      </PromoFooter>
    </PromoPanelRoot>
  );
};
